import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { t } from "i18next";

import formatDuration from "./formatDuration";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { useFormattedUnit } from "@/hooks/metrics/useFormattedUnit";
import { useGetColorByValue } from "@/pages/diagnosticmonitor/hooks/useGetColorByValue";

// TODO COlorIntervals
export function CompactDiagnosticCell({ value, row }: GridRenderCellParams) {
  const data = value?.data;
  const { diagnosticUnits, precisions, hideOldData } = useDataGridSettings();
  const getColorByValue = useGetColorByValue();
  const unit = diagnosticUnits.find(du => du.diagnosticId === row?.id);
  const dunit = unit?.displayUnitOfMeasure;
  const precision = precisions[row?.id] ?? 0;
  const formattedValue = useFormattedUnit(
    data,
    precision,
    dunit?.name,
    dunit?.factorFromBase,
    dunit?.offsetFromBase,
  );
  const now = new Date();
  const diffMillis = now.getTime() - value?.dateTime;
  const formattedTime = formatDuration(diffMillis);

  const valueInUnit = dunit?.factorFromBase ? data * dunit?.factorFromBase : data;
  const color = getColorByValue(row?.id, valueInUnit);
  const hr24Millis = 24 * 60 * 60 * 1000;
  const hideData = diffMillis > hr24Millis && hideOldData;

  return (
    <Tooltip
      sx={{ height: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}
      title={data ? t("deviceStatus.lastUpdated") + formattedTime : ""}
    >
      <Box color={!hideData ? color : "#808080"}>{formattedValue ? formattedValue : "---"}</Box>
    </Tooltip>
  );
}
